// src/pages/Partners.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Handshake, HeartHandshake, ArrowRightCircle } from 'lucide-react';
import PartnerSpotlight from '../components/PartnerSpotlight';

const Partners = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Page hero */}
            <header className="relative overflow-hidden bg-gradient-to-br from-purple-900 via-purple-800 to-purple-950 pt-32 pb-24">
                <div className="pointer-events-none absolute inset-0">
                    <div className="absolute -top-10 left-1/4 h-72 w-72 rounded-full bg-purple-500/20 blur-3xl" />
                    <div className="absolute bottom-0 right-1/4 h-64 w-64 rounded-full bg-gold-400/10 blur-3xl" />
                </div>
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
                    <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10
                                     px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-purple-100 backdrop-blur-sm">
                        <Handshake className="h-4 w-4" />
                        Standing With Us
                    </span>
                    <h1 className="mt-5 font-display text-5xl sm:text-6xl font-semibold text-white">
                        Our{' '}
                        <span className="bg-gradient-to-r from-gold-200 to-white bg-clip-text italic text-transparent">
                            Partners
                        </span>
                    </h1>
                    <p className="mx-auto mt-5 max-w-2xl text-lg text-purple-100/80">
                        Every meal served, every survivor supported, and every young entrepreneur
                        mentored is made possible by partners who choose to give back. We are proud
                        to celebrate the businesses standing with our community.
                    </p>
                </div>
            </header>

            {/* Premier partner spotlight (Christo's Supermarket) */}
            <PartnerSpotlight />

            {/* Become a partner CTA */}
            <section className="py-24 bg-gradient-to-b from-white to-purple-50">
                <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
                    <div className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-2xl
                                    bg-gradient-to-br from-purple-600 to-purple-500 shadow-lg rotate-3">
                        <HeartHandshake className="h-8 w-8 text-white -rotate-3" />
                    </div>
                    <h2 className="font-display text-4xl font-semibold text-gray-900">
                        Become a Partner
                    </h2>
                    <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-gray-600">
                        Join a community of changemakers. Whether through sponsorship, in-kind
                        donations, or shared initiatives, your partnership helps us reach further
                        and serve more families across our community.
                    </p>
                    <Link
                        to="/contact"
                        className="group mt-8 inline-flex items-center rounded-full bg-purple-600 px-8 py-4
                                   font-semibold text-white shadow-lg transition-all duration-300
                                   hover:-translate-y-1 hover:bg-purple-700 hover:shadow-xl"
                    >
                        Partner With Us
                        <ArrowRightCircle className="ml-2 h-5 w-5 transition-transform duration-500 group-hover:rotate-90" />
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Partners;
